import { useEffect, useState } from "react";
import {
  Grid,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import OrderCard from "./OrderCard";
import request from "../utilities/requests";

const UserOrders = ({ user }) => {
  const [orders, setOrders] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);

  const getOrders = async () => {
    try {
      setLoading(true);
      const result = await request(
        `ticketing/admin/orders/?userId=${user._id}`
      );
      if (result.success) {
        setOrders(result.data);
      } else {
        setOrders([]);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user && expanded) {
      getOrders();
    }
  }, [user, expanded]);

  return (
    <Grid item xs={12}>
      <Paper height={3}>
        <Accordion
          expanded={expanded}
          onChange={(_, isExpanded) => {
            setExpanded(isExpanded);
            if (isExpanded && (!orders || orders.length === 0)) {
              getOrders();
            }
          }}
          slotProps={{ transition: { unmountOnExit: true } }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <ListItemButton style={{ fontWeight: "bold" }}>
              Orders
            </ListItemButton>
          </AccordionSummary>

          <AccordionDetails>
            {loading && (
              <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                <CircularProgress size={24} />
              </Box>
            )}
            {!loading && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                {(!orders || orders.length === 0) && (
                  <Alert severity="info">No orders found for this user.</Alert>
                )}

                {orders.map((order) => (
                  <OrderCard
                    key={order.orderId || order._id}
                    order={order}
                    onRefundSuccess={getOrders}
                  />
                ))}
              </div>
            )}
          </AccordionDetails>
        </Accordion>
      </Paper>
    </Grid>
  );
};

export default UserOrders;
